// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2bktT","colMin":"styles_colMin__qEsKL","colCheckbox":"styles_colCheckbox__xRjBx"};